<template>
  <v-app-bar
    color="primary"
    fixed
    dark
    >
    <v-app-bar-title class="ml-0 pl-3">
      <v-app-bar-nav-icon @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
    </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-bind="attrs" v-on="on">
            <v-avatar size="30px">
              <v-icon>person</v-icon>
            </v-avatar>
          </v-btn>
        </template>
          <v-list class="pa-0">
            <v-list-item v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
      </v-menu>
  </v-app-bar>
</template>

<script>
import Util from '@/util'

export default {
  name: 'app-toolbar',
  components: {
  },
  data: () => ({
    items: [
      {
        icon: 'account_circle',
        href: '#',
        title: '帐号',
        click: (e) => {
          window.getApp.$emit('APP_PROFILE')
        }
      },
      {
        icon: 'settings',
        href: '#',
        title: '设置',
        click: (e) => {
          window.getApp.$emit('APP_SETTINGS')
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: '退出',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT')
        }
      }
    ]
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav
    }
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED')
    },
    handleFullScreen () {
      Util.toggleFullScreen()
    }
  }
}
</script>
